import request from '@/utils/request'

/**
 * 查询用户地址列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listUserAddresses(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/userAddress.queryUserAddress',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存用户地址
 * @param {Object} data 地址数据
 * @returns {Promise} Promise对象
 */
export function saveUserAddress(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/userAddress.saveUserAddress',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除用户地址
 * @param {Object} data 地址数据
 * @returns {Promise} Promise对象
 */
export function deleteUserAddress(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/userAddress.deleteUserAddress',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询地区列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listAreas(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/area.listAreas',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}